import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AddShipModel } from 'src/app/interface/fleetList.interface';
import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-add-ships',
  templateUrl: './add-ships.component.html',
  styleUrls: ['./add-ships.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddShipsComponent implements OnInit {

  toggleState:boolean = false;
  @Input() shipOwnerlist:any;
  @Input() subPoolslist:any;
  @Input() addShipdata:any;
  @Output() selected_Date = new EventEmitter<string>();
  @Output() searchVal = new EventEmitter<any>();
  @Output() shipSubpool = new EventEmitter<any>();
  @Output() shipOwner = new EventEmitter<any>();
  shipOwners: any = [];
  subPool:any = [];
  viewModel: AddShipModel  = {
    searchText:'',
    searchInput:true,
    fleet: '',
    addShipSubmit: false,
    owners:[],
    minDate: new Date(),
    imosNew:[],
    imosNewTemp:[],
    selectdShip:[],
    addShipList:[],
    shipsFromDragListTemp:[],
    shipsFromdragListCopyTemp:[],
    shipsData:[],
    
  }
  scrubberVal: any;
  newAddship:any = [];
  switchScrubber:boolean = false;
  switchLng:boolean = false;
  dateSelected: any;
  showDatetext: boolean = false;
  searchText:any;
  updateSubpool: any;
  updateShipowner:any;
  updateSearch: any;
  updateClass:string = '';
  updateDate:any;
  selectedSubpool: any;
  selectedShipOwner:any;
  shipErrorMessage: boolean;
  getAddShipdateselected: any;
  constructor( private _vesselService: VesselsService) {
  }

  ngOnInit() {
    this.viewModel.shipsData = this.addShipdata;
    this.viewModel.shipsData = this.viewModel.shipsData?.map((items:any)=>({id: items.vslCode ,
    name: this.convertFirstLetterToUpperCase(items?.vslName) + ' / ' + items.vslNumber   }))
    console.log("1",this.viewModel.shipsData);
    console.log(this.addShipdata)
    console.log(this._vesselService.serachShipData)
    console.log(this._vesselService.storePoolval)
    if(this._vesselService.serachShipData?.length){
      this.updateSearch = this._vesselService.serachShipData[0]?.vslName + '(' + this._vesselService.serachShipData[0]?.vslNumber + ')';
      this.updateClass = this._vesselService.serachShipData[0]?.vslClass;
    }
    if(this.subPoolslist?.length && this.subPoolslist?.length < 2){
      this.selectedSubpool = this.subPoolslist;
      this.subPool = this.subPoolslist[0]?.name;
      console.log("new 1",this.selectedSubpool)
      this._vesselService.addSubpoolfilterval = this.subPool;
      this.shipSubpool.emit(this.subPool)
    }else if(this.subPoolslist?.length && this.subPoolslist?.length > 1 && this._vesselService.addSubpoolfilterval){
      // console.log("2",this.subPoolslist)
      this.selectedSubpool = this.subPoolslist.filter((items:any)=>items?.name === this._vesselService.addSubpoolfilterval);
      console.log("22",this.selectedSubpool)
    }else{
      let getSelectedPoolTab = this._vesselService.storePoolval;
      if(this._vesselService.storePoolval !== 'all ships'){
        this.selectedSubpool = this.subPoolslist.filter((items:any)=>items?.name === getSelectedPoolTab);
        console.log("add in pool",this.selectedSubpool )
        this.subPool = this.selectedSubpool[0]?.name;
        this._vesselService.addSubpoolfilterval = this.subPool;
        this.shipSubpool.emit(this.subPool)
      }else{
        this.selectedSubpool = [];
      }
     
      console.log("new",this.selectedSubpool)
    }
    console.log("owner",this.shipOwnerlist)
    if(this.shipOwnerlist?.length){
      this.selectedShipOwner = this.shipOwnerlist.filter((items:any)=>items?.name === this._vesselService.addShipfilterval?.selectedRecords?.name);
    }else{
      this.selectedShipOwner = [];
    }
    // if (this._vesselService.addSubpoolfilterval) {
    //   this.updateSubpool = this._vesselService.addSubpoolfilterval;
    // }
    // if(this._vesselService.addShipfilterval?.selectedRecords?.name){
    //   this.updateShipowner = this._vesselService.addShipfilterval.selectedRecords?.name;
    // }
    this.selected_Date.emit(this._vesselService.addShipdateselected)
    this.getAddShipdateselected = this._vesselService.addShipdateselected;
    console.log("this.getAddShipdateselected",this.getAddShipdateselected)
    if(this._vesselService.addShipdateselected){
      this.updateDate = this._vesselService.addShipdateselected;
      let todaysDate = new Date();
      if(this._vesselService.addShipdateselected > todaysDate){
        this.showDatetext = true;
      }else{
        this.showDatetext = false;
      }
    }
    if(this._vesselService.scrubberToggleval){
      this.switchScrubber = this._vesselService.scrubberToggleval;
    }
    if(this._vesselService.lngToggleval){
      this.switchLng = this._vesselService.lngToggleval
    }
  }
  
  convertFirstLetterToUpperCase(str: any) {
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }
  
  // toggleStateChangeScrubber(e:any){
  //   console.log(e)
  // }

  // toggleStateChangeLng(e:any){
  //   console.log(e)
  // }

  valueChange(event:any){
    console.log(event)
    this.newAddship = this.addShipdata;
    this.switchScrubber = false;
    this.switchLng = false;
    this.scrubberVal = this.newAddship?.filter((item:any)=>item?.vslCode === event)
    console.log("sss",this.scrubberVal)
    this.searchVal.emit(this.scrubberVal)
    this._vesselService.serachShipData = this.scrubberVal;
    this.updateSearch = '';
    this.updateClass = ''
    if(this.scrubberVal?.length){
      this.switchScrubber = this.scrubberVal[0]?.scrubberType === 0 ? false : true;
      this._vesselService.scrubberToggleval = this.switchScrubber;
      console.log(this.switchScrubber)
    }
    if(this.scrubberVal?.length){
      this.switchLng = this.scrubberVal[0]?.lng === 0 ? false : true;
      this._vesselService.lngToggleval = this.switchLng;
      console.log(this.switchLng)
    }
  
  }
  toggleScrubber(e:any){
    console.log(e)
    this._vesselService.scrubberToggleval = e?.isSwitchActive;
  }
  toggleLng(e:any){
    console.log(e)
    this._vesselService.lngToggleval = e?.isSwitchActive;
  }
  selectedValues(event: any, field: string) {
    console.log(event,field)
    if(field === 'shipOwner'){
      this.shipOwners = event.selectedRecords?.name;
      console.log(this.shipOwners)
      this._vesselService.addShipfilterval = event;
      this.selectedShipOwner.push(event.selectedRecords)
      console.log(this.selectedShipOwner)
      // this.updateShipowner = '';
      console.log(this._vesselService.addShipfilterval)
      this.shipOwner.emit(this.shipOwners)
    }
    if(field === 'shipPool'){
      this.subPool =  event.selectedRecords?.name;
      console.log(event.selectedRecords)
      this.selectedSubpool.push(event.selectedRecords);
      console.log(this.selectedSubpool)
      this._vesselService.addSubpoolfilterval = this.subPool;
      // this.updateSubpool = '';
      this.shipSubpool.emit(this.subPool)
    }
  }
  selectedDate(event: any) {
    console.log(event)
    this.dateSelected = event;
    let todaysDate = new Date();
    console.log(todaysDate)
    this.getAddShipdateselected =  this.dateSelected;
    if(this.dateSelected > todaysDate){
      this.showDatetext = true;
    }else{
      this.showDatetext = false;
    }
    this._vesselService.addShipdateselected = this.dateSelected;
    this._vesselService.showDatestatus = this.showDatetext;
    this.selected_Date.emit(this.dateSelected);
    this.updateDate = null;
    
  }
    public resetDropdown(event: any, field: string) {
      console.log(field)
      console.log(event)
    if ((this.selectedShipOwner?.length && field === 'shipOwner') || (this.selectedSubpool?.length && field === 'shipPool')) {
      if (field === 'shipOwner') {
        this.selectedShipOwner = [];
        this.shipOwners = '';
        this.shipOwner.emit(this.shipOwners)
      } else if (field === 'shipPool') {
        this.selectedSubpool = [];
        this.subPool = '';
        this.shipSubpool.emit(this.subPool)
      } 
     
    }
  }
  noShipFoundEvent(e:any){
    console.log(e)
    this.shipErrorMessage = e;
  }
}